export function debounce(fn, time) {
  if (time === void 0) {
    time = 300;
  }
  let timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new Promise((resolve, reject) => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        try {
          const res = fn(...args);
          resolve(res);
        } catch (e) {
          reject(e);
        }
      }, time);
    });
  };
}
//# sourceMappingURL=debounce.js.map